var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-file-drop"},[_c('div',{ref:"dropZone",staticClass:"base-file-drop__zone",on:{"submit":function($event){$event.preventDefault();}}},[_c('base-spinner'),_c('input',{staticClass:"base-file-drop__input",attrs:{"type":"file"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }